<template>
  <modal
    name="configure-auction-modal"
    class="configure-auction-modal"
    transition="fade"
    :adaptive="true"
    :scrollable="true"
    width="60%"
    height="65%"
  >
    <div id="modal-header" >
      <div class="w-100 d-flex">
        <p>
          Կառավարել աճուրդը
        </p>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('configure-auction-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body">
      <form>
        <div class="row">
          <div class="form-group col-md-6">
            <div class="mb-3 pl-1">
              <label for="name">Աճուրդի սկսման օր</label>
              <date-pick
                v-model="startDate"
                class="date-picker tender-date-picker "
                setTimeCaption='Ժամը՝'
                :format="'YYYY-MM-DD'"
                :pickTime="false"
                :weekdays="['Երկ', 'Երք', 'Չոր', 'Հին', 'Ուր', 'Շբթ', 'Կիր']"
                :months="['Հունվար', 'Փետրվար', 'Մարտ', 'Ապրիլ', 'Մայիս', 'Հունիս', 'Հուլիս', 'Օգոստոս', 'Սեպտեմբեր', 'Հոկտեմբեր', 'Նոյեմբեր', 'Դեկտեմբեր']"
                :inputAttributes="{readonly: true, placeholder: 'Աճուրդի սկսման օր'}"
                id="auction-opening-date"
                :isDateDisabled="isPastDate"
              />
            </div>
          </div>
          <div class="form-group col-md-6">
            <div class="mb-3 pl-1">
              <label for="name">Աճուրդի սկսման ժամ</label>
              <select v-model="startTime" class="form-control">
                <option
                  v-for="time in timeOptions()"
                  :key="time"
                  :value="time"
                >
                  {{ time }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group col-md-6">
            <div class="mb-3 pl-1">
              <label for="name">Աճուրդի տևողություն /յուրաքանչյուր չափաբաժնի համար/</label>
              <select class="form-control"
                      v-model="form.duration"
              >
                <option value="5">5 Րոպե</option>
                <option value="10">10 Րոպե</option>
                <option value="15">15 Րոպե</option>
              </select>
            </div>
          </div>
          <div class="form-group col-md-6">
            <div class="mb-3 pl-1">
              <label for="name">Քայլի նվազագույն տոկոս</label>
              <select
                class="form-control"
                v-model="form.step"
              >
                <option value="0.5">0.5%</option>
                <option value="1">1%</option>
                <option value="2">2%</option>
                <option value="3">3%</option>
                <option value="4">4%</option>
                <option value="5">5%</option>
              </select>
            </div>
          </div>
        </div>

      </form>
    </div>
    <div id="modal-footer">
      <button @click="$modal.hide('configure-auction-modal')" class="btn btn-light mr-3">
        Չեղարկել
      </button>
      <button :disabled="isLoading" @click="save" class="btn btn-primary br-8">
        <span v-if="isLoading" class="mr-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span>Պահպանել</span>
      </button>
    </div>
  </modal>
</template>

<script>
import DatePick from "vue-date-pick";

export default {
  name: 'ConfigureAuctionModal',
  components: {DatePick},
  data() {
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)

    return {
      isLoading: false,
      startDate: tomorrow.toISOString().split('T')[0],
      startTime: '09:00',
      form: {
        organize_id: this.$route.params.id,
        step: 0.5,
        start_at: null,
        duration: 10,
      }
    }
  },
  computed: {
    currentOrganized() {
      return this.$store.getters['organizeItender/currentOrganized']
    },
  },
  methods: {
    isPastDate(date) {
      const today = new Date()

      today.setHours(0, 0, 0, 0)
      date.setHours(0, 0, 0, 0)

      return date < today
    },
    timeOptions() {
      const times = []

      for (let hour = 9; hour <= 18; hour++) {
        for (let min = 0; min < 60; min += 30) {

          // stop after 18:00
          if (hour === 18 && min > 0) {
            break
          }

          const h = String(hour).padStart(2, '0')
          const m = String(min).padStart(2, '0')

          times.push(`${h}:${m}`)
        }
      }

      return times
    },
    async save() {
      try {
        this.form.start_at = `${this.startDate} ${this.startTime}`
        await this.$client2.post('auction/create', this.form);

        this.$notify({
          group: 'foo',
          type: 'success',
          text: 'Դուք հաջողությամբ ստեղծեցիք աճուրդ'
        })

        await this.$store.dispatch('organizeItender/getCurrent', this.currentOrganized.id)

        this.$modal.hide('configure-auction-modal')

      } catch (e) {
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Ինչ որ բան այն չէ',
          text: 'Կրկին փորձեք!'
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
